module.exports = __webpack_public_path__ + "img/ivan.ee555995.jpeg";